import { useEffect } from "react";
import { Button } from "../../ui/primitives/Button";
import { Card, CardBody, CardHeader } from "../../ui/primitives/Card";

export function UnauthorizedPage() {
  useEffect(() => {
    document.title = "Unauthorized";
  }, []);

  return (
    <div className="min-h-screen bg-bg text-fg flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader
          title="Access denied"
          subtitle="We couldn’t show you this page"
        />

        <CardBody>
          <div className="space-y-4 text-sm text-muted">
            <p>
              It looks like your access rights were not set correctly, or your
              session has expired.
            </p>

            <p>
              Try starting again from the Portal main page.
            </p>
          </div>

          <div className="mt-6 space-y-3">
            <Button as="a" href="/index.html" variant="primary">
            Open Portal
            </Button>

            <div className="text-center text-xs text-muted">
              Questions? Contact us at{" "}
              <a
                href="mailto:info@bushinconsulting.com"
                className="underline hover:text-primary"
              >
                info@bushinconsulting.com
              </a>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
